import React, { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./Navbar";
import "./App.css"
import Footer from "./Footer";
import Home from "./Home";
import MaintenancePage from "./resources/MaintenancePage"; // Import the MaintenancePage component
import Sell from "./Sell";
import Modallogin from "./Modallogin";
import SellForm from "./SellForm";
import AdSuccess from "./SellFormComponents/AdSuccess";
import UserProfileEdit from "./UserProfileEdit";
import Profile from "./Profile";
import NotFound from "./resources/NotFound";
import Myads from "./Myads";
import PreviewAd from "./PreviewAd";
import CatagoryView from "./CatagoryView";
import SearchResults from "./SearchComponents/SearchResults";
import MyChat from "./MyChat";
import SearchProfile from "./SearchProfile";
import { API_BASE_URL } from './config/api_keys';
import Loading from "./resources/Loading";
import SocialMedia from "./SocialMedia";
import MobileBottomNav from "./components/MobileBottomNav";
import MobileHeader from "./components/MobileHeader";
import WeatherPage from "./components/Weather/WeatherPage";
import "./MobileBottomNav.css";
import LivestockPage from "./Livestock";
import BuyPashuAhar from "./pages/BuyPashuAhar";
import ChemicalsPage from "./ChemicalsPage";
import Chatbot from "./ChatComponents/Chatbot";
import MandiBhav from "./pages/mandiBhav";
import StoreForm from "./components/Store/StoreForm";
import StoreList from "./components/Store/StoreList";
import StoreDetail from "./components/Store/StoreDetail";
import ProductDetails from "./components/Product/ProductDetails";
import BusinessmenList from "./components/BusinessmenList/BusinessmenList";
import AnimalDetail from "./components/AnimalDetail";
import EditProduct from "./EditProduct";
import EditAnimal from "./EditAnimal";
import AdminStore from "./components/Store/AdminStore";
// Import the new FloatingAIAssistant component
import FloatingAIAssistant from "./ChatComponents/FloatingAIAssistant";
const SellAnimal = lazy(() => import('./components/SellAnimal'));
const AddSpecializedProduct = lazy(() => import('./components/Store/AddSpecializedProduct'));

// Lazy load heavy components
const GovernmentSchemesComponent = lazy(() => import('./components/GovernmentSchemes/GovernmentSchemes'));
const PmsbySchemeComponent = lazy(() => import('./components/PmsbyScheme/PmsbyScheme'));
const PmFasalBimaComponent = lazy(() => import('./components/PmsbyScheme/PmFasalBima'));

function App() {
  // for modal 
  const [staticModal, setStaticModal] = useState(false);
  const toggleShow = () => setStaticModal(!staticModal);
  const [activeTab, setActiveTab] = useState('tab1');

  const [auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true); // Initial loading state
  const [backendStatus, setBackendStatus] = useState('online'); // Track backend status
  const [isMobile, setIsMobile] = useState(false);

  // Check if screen is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Fix for ResizeObserver loop error
  useEffect(() => {
    // This will suppress the ResizeObserver loop error
    const originalError = console.error;
    console.error = (...args) => {
      if (
        args[0]?.includes?.('ResizeObserver loop') ||
        args[0]?.includes?.('ResizeObserver Loop') ||
        (typeof args[0] === 'string' && args[0].indexOf('ResizeObserver') !== -1)
      ) {
        // Ignore ResizeObserver errors
        return;
      }
      originalError(...args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  async function checkBackendStatus() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/check-status`);
      const data = await response.json();
      setBackendStatus(data.status);
    } catch (error) {
      setBackendStatus('offline');
    } finally {
      setLoading(false);
    }
  }

  // Function to check user authentication status
  async function checkAuthentication() {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        console.log('User is not authenticated');
        setAuth(false);
        setLoading(false);
        return;
      }
      const response = await fetch(`${API_BASE_URL}/auth-endpoint`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
      const data = await response.json();

      if (data.isAuthenticated) {
        console.log('User is authenticated');
        setAuth(true);
      } else {
        console.log('User is not authenticated');
        setAuth(false);
        // Clear invalid token
        localStorage.removeItem('authToken');
      }
    } catch (error) {
      console.error('Authentication error:', error);
      setAuth(false);
      // Clear potentially invalid token on error
      localStorage.removeItem('authToken');
    } finally {
      // Authentication check is complete, update loading state
      setLoading(false);
    }
  }
  

  useEffect(() => {
    checkBackendStatus();
    checkAuthentication();
  }, []);

    if (loading) {
    return <Loading />;
  }

  return (
    <div className="App">

     {/* routes */}
     {backendStatus === 'online' ? (
     <Router>
      <ScrollToTop />
      {/* Show appropriate header based on device */}
      {isMobile ? <MobileHeader /> : <Navbar auth={auth} setAuth={setAuth} staticModal={staticModal} toggleShow={toggleShow} setActiveTab={setActiveTab} />}
      
      {/* Add the Floating AI Assistant component */}
      <FloatingAIAssistant />
      
      <Routes>
        <Route path="/" element={<Home auth={auth} setStaticModal={setStaticModal} toggleShow={toggleShow} setActiveTab={setActiveTab} />} />
        <Route path="/adsuccess" element={<AdSuccess />} />
        <Route path="/preview_ad/:id" element={<PreviewAd auth={auth} />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/animals/:id" element={<AnimalDetail auth={auth} />} />
        <Route path="/attributes/:category/:item" element={<SellForm />} />
        {auth === true && <Route path="/chat/:id/:useremail" element={<MyChat />} />}
        {auth === true && <Route path="/chat" element={<MyChat />} />}
        {auth === true && <Route path="/editprofile" element={<UserProfileEdit />} />}
        {auth === true && <Route path="/profile" element={<Profile />} />}
        {auth === true && <Route path="/myads" element={<Myads />} />}
        {auth === true && <Route path="/mychat" element={<MyChat />} />}
        {auth === true && <Route path="/maintenance" element={<MaintenancePage />} />}
        <Route path="/livestock" element={<LivestockPage />} />
        <Route path="/buy-pashu-ahar" element={<BuyPashuAhar />} />
        {auth === true && <Route path="/sell" element={<Sell />} />}
        {auth === false && <Route path="/sell" element={
          <>
            <Modallogin setStaticModal={setStaticModal} toggleShow={toggleShow} staticModal={staticModal} activeTab={activeTab} />
            <Home />
          </>
        } />}
        <Route path="/social" element={<SocialMedia auth={auth} />} />
        <Route path="/weather" element={
          <Suspense fallback={<Loading />}>
            <WeatherPage />
          </Suspense>
        } />
        <Route path="/government-schemes" element={
          <Suspense fallback={<Loading />}>
            <GovernmentSchemesComponent />
          </Suspense>
        } />
         <Route path="/pashu-bima" element={
           <Suspense fallback={<Loading />}>
             <PmsbySchemeComponent />
           </Suspense>
         } />
         <Route path="/mandi-bhav" element={<MandiBhav/>} />
         <Route path="/fasal-bima" element={
           <Suspense fallback={<Loading />}>
             <PmFasalBimaComponent />
           </Suspense>
         } />
        <Route path="/chemicals" element={<ChemicalsPage />} />
        <Route path="/chatbot" element={<Chatbot/>} />
        <Route path = "/businessmen" element={<BusinessmenList />}/>
        <Route path="/admin-store" element={<AdminStore />} />
        <Route path="/create-store" element={auth ? <StoreForm /> : <Modallogin setStaticModal={setStaticModal} toggleShow={toggleShow} staticModal={staticModal} activeTab={activeTab} />} />
        <Route path="/store/:id" element={<StoreDetail />} />
        <Route path="/stores" element={<StoreList />} />
        <Route path="/components/Store/AddSpecializedProduct" element={auth ? 
          <Suspense fallback={<Loading />}>
            <AddSpecializedProduct />
          </Suspense> : 
          <Modallogin setStaticModal={setStaticModal} toggleShow={toggleShow} staticModal={staticModal} activeTab={activeTab} />
        } />
        {/* Add the edit product route */}
        {auth === true && <Route path="/edit-product/:id" element={<EditProduct />} />}
        {/* Add the animal routes */}
        {auth === true && <Route path="/sell-animal" element={
          <Suspense fallback={<Loading />}>
            <SellAnimal />
          </Suspense>
        } />}
        {auth === true && <Route path="/edit-animal/:id" element={<EditAnimal />} />}
        <Route path="/:category" element={<CatagoryView />} />
        <Route path="/results" element={<SearchResults />} />
        <Route path="/profile/:useremail" element={<SearchProfile />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {isMobile && <MobileBottomNav setStaticModal={setStaticModal} toggleShow={toggleShow} setActiveTab={setActiveTab} />}
      {!auth && staticModal && <Modallogin setStaticModal={setStaticModal} toggleShow={toggleShow} staticModal={staticModal} activeTab={activeTab} />}
    </Router>
      ) : (
        // Render the maintenance page when the backend is down
        <MaintenancePage />
      )}


      {/* USE FOOTER */}
      <Footer />

    </div>
  );
}

export default App;